module.exports = __webpack_public_path__ + "static/media/SS01.5faaa729.jpg";